import { Logger } from '@elyx-code/common-ts-utils';
import { IDataBase, Connection } from 'jsstore';
import SqlWeb from 'sqlweb';

const getWorkerPath = () => {
	try {
		if (process.env.NODE_ENV === 'development') {
			return require('file-loader?name=scripts/[name].[hash].js!jsstore/dist/jsstore.worker.js');
		} else {
			return require('file-loader?name=scripts/[name].[hash].js!jsstore/dist/jsstore.worker.min.js');
		}
	} catch (ex) {
		// Logger.error(ex);
		return {
			default: '',
		};
	}
};

// Ensure that we are using only one instance.
// Otherwise due to multiple instance multiple worker will be created.
const workerPath = getWorkerPath().default;

export const initLocalDBConnection = async (): Promise<
	Connection & {
		$sql: {
			run: (sql: string) => Promise<any>;
		};
	} & {
		database: IDataBase;
	}
> => {
	try {
		const idbCon = !!workerPath
			? new Connection(new Worker(workerPath))
			: new Connection();

		// Add SqlWeb so we can use raw SQL queries
		await idbCon.addPlugin(SqlWeb);

		return idbCon as Connection & {
			$sql: {
				run: (sql: string) => Promise<any>;
			};
		} & {
			database: IDataBase;
		};
	} catch (ex) {
		Logger.log('Here');
		Logger.error('HERE :', ex);
	}
};

export const initLocalIndexedDatabase = async (
	connection: Connection,
	database: IDataBase
): Promise<boolean> => {
	try {
		Logger.log('Initializing database at jsstore level');

		return connection.initDb(database);
	} catch (ex) {
		Logger.log('Here');
		Logger.error('HERE :', ex);
	}
};
